import React from "react";
import "./scss/_app.scss";
import * as Constants from "./Constants";
import ApiService from "./services/ApiService";
import WordpressMobile from "./components/WordpressMobile";
import WordpressDropdown from "./components/WordpressDropdown";
import TimetableDropdown from "./components/TimetableDropdown";
import AppDropdown from "./components/AppDropdown";
import SchoolSwitcherDropdown from "./components/SchoolSwitcherDropdown";

class App extends React.Component {
  token = document.getElementById("root").dataset.token;
  loginButton = document.getElementById("root").dataset.loginButton;
  schoolId = document.getElementById("root").dataset.school;
  wordpress = document.getElementById("root").dataset.wordpress ? 4 : 3;

  state = {
    starredApps: [],
    apps: [],
    school: {},
    schools: [],
    member: {},
    timetable: false,
    loginLinks: [],
    defaultLoginButtonDisabled: false,
    waitTimer: 1000,
  };

  constructor(props) {
    super(props);
    this.apiService = new ApiService(this.token);
  }

  componentDidMount() {
    this.getLoginLinks();
    if (this.token.length !== 0) {
      this.getApps(this.schoolId);
      this.getTimetable();
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  async getTimetable() {
    this.apiService
      .getTimetable()
      .then((data) => {
        this.setState({ timetable: data });
      })
      .catch((error) => {
        console.error("Error fetching timetable:", error);
        this.setState({ timetable: false });
      });
  }

  async getApps() {
    const data = this.apiService
      .getApps(this.schoolId)
      .then((data) => {
        this.setState({
          starredApps: data.starredApps ? data.starredApps : [],
          apps: data.apps ? data.apps : [],
          school: data.school ? data.school : {},
          member: data.member ? data.member : {},
          schools: data.schools ? data.schools : [],
        });
      })
      .catch((error) => {
        console.error("Error fetching apps:", error);
        setTimeout(() => this.getApps(), this.state.waitTimer * 2);
      });
  }

  async getLoginLinks() {
    const data = this.apiService
      .getLoginLinks(this.schoolId)
      .then((data) => {
          this.setState(data);
      })
      .catch((error) => {
        console.error("Error fetching login links:", error);
        setTimeout(() => this.getLoginLinks(), this.state.waitTimer * 2);
      });
  }

  render() {
    return (
      <div>
        {this.token.length === 0 && this.loginButton === "true" && (
          <div id="login-bar">
            {this.state.loginLinks.map((link, i) => (
              <a
                className="login-button"
                alt="login button"
                key={i}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.text}
              </a>
            ))}
            {this.state.defaultLoginButtonDisabled === false &&
              (
                <a
                  className="login-button"
                  alt="login button"
                  href={
                    window.location.origin +
                    (this.wordpress === 4 ? "/wordpress" : "") +
                    "/wp-login.php" +
                    (this.schoolId !== "false"
                      ? "?school=" + this.schoolId
                      : "")
                  }
                >
                  Login
                </a>
              )}
          </div>
        )}
        {this.token.length !== 0 &&
          typeof this.state.school.sc_name !== "undefined" && (
            <div id="smartpanel">
              <div className="wrapper">
                <div className="cpanel__logo">
                  {typeof this.state.school !== "undefined" && (
                    <img
                      width="35px"
                      height="35px"
                      src={
                        typeof this.state.school.sc_logo !== "undefined" &&
                        this.state.school.sc_logo != null
                          ? "https://cdn.realsmart.co.uk/sc_logos/" +
                            this.state.school.sc_logo
                          : "https://cdn.realsmart.co.uk/new-cpanel/school-logo-placeholder.png"
                      }
                      alt="realsmart logo"
                    />
                  )}
                </div>
                <div className="main-apps--mobile">
                  {typeof this.state.member !== "undefined" &&
                    ["admin", "mentor", "governor"].indexOf(
                      this.state.member.type
                    ) !== -1 && <WordpressMobile school={this.state.school} />}
                </div>
                <div className="main-apps">
                  <ul className="main-apps-list">
                    {typeof this.state.member !== "undefined" &&
                      ["admin", "mentor", "governor"].indexOf(
                        this.state.member.type
                      ) !== -1 && (
                        <WordpressDropdown
                          school={this.state.school}
                          wordpress={this.wordpress}
                        />
                      )}
                    {this.state.starredApps.map((app, i) => (
                      <li
                        className="main-apps__app-icon cpanel-tooltip"
                        key={i}
                      >
                        <a
                          href={app.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          alt="app"
                          className="app-icon-link"
                          style={{
                            backgroundImage: 'url("' + app.image + '")',
                          }}
                        >
                          {app.badge && (
                            <span className="mail-badge">{app.badge}</span>
                          )}
                          <span className="app-name">{app.title}</span>
                          <span className="tooltiptext">{app.title}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="cpanel__other-apps">
                  <ul className="other-apps">
                    {this.state.schools.length !== 0 && (
                      <SchoolSwitcherDropdown schools={this.state.schools} />
                    )}
                    <AppDropdown
                      starredApps={this.state.starredApps}
                      apps={this.state.apps}
                    />
                    {this.state.timetable !== false && (
                      <TimetableDropdown
                        timetableItems={this.state.timetable}
                      />
                    )}
                    <li className="other-apps__app-icon app-icon--user">
                      {!this.state.member.pic && (
                        <a
                          href={Constants.AdminURL + "/admin#!/profile"}
                          target="_blank"
                          rel="noopener noreferrer"
                          alt="app"
                          className="cpanel-tooltip"
                        >
                          <img
                            alt="Profile Icon"
                            src="https://cdn.realsmart.co.uk/new-cpanel/cpanel-user-icon.svg"
                            className="app-icon app-icon-wordpress"
                          />
                          <span className="tooltiptext">Profile</span>
                        </a>
                      )}
                      {this.state.member.pic && (
                        <a
                          href={Constants.AdminURL + "/admin#!/profile"}
                          target="_blank"
                          rel="noopener noreferrer"
                          alt="app"
                          className="cpanel-tooltip"
                        >
                          <img
                            alt="Profile"
                            src={
                              "https://cdn.realsmart.co.uk/st_pictures/" +
                              this.state.member.pic
                            }
                            className="app-icon app-icon-wordpress"
                          />
                          <span className="tooltiptext">Profile</span>
                        </a>
                      )}
                    </li>
                    {this.state.member.type === "admin" && (
                      <li className="other-apps__app-icon app-icon--user">
                        <a
                          href={Constants.AdminURL + "/admin#!"}
                          target="_blank"
                          rel="noopener noreferrer"
                          alt="app"
                          className="cpanel-tooltip"
                        >
                          <img
                            alt="smartAdmin Icon"
                            src="https://cdn.realsmart.co.uk/new-cpanel/cpanel-smartadmin-cog-icon.svg"
                            className="app-icon app-icon-wordpress"
                          />
                          <span className="tooltiptext">Smart Admin</span>
                        </a>
                      </li>
                    )}
                    <li className="other-apps__app-icon app-icon--settings">
                      {this.schoolId === "false" && (
                        <a
                          href={Constants.LogoutUrl}
                          alt="app"
                          className="cpanel-tooltip"
                        >
                          <img
                            alt="Logout Icon"
                            src="https://cdn.realsmart.co.uk/new-cpanel/cpanel-logout-icon.svg"
                            className="app-icon app-icon-wordpress"
                          />
                        </a>
                      )}
                      {this.schoolId !== "false" &&
                        this.state.school.sc_wordpress_url !== "" && (
                          <a
                            href={Constants.LogoutUrl}
                            alt="app"
                            className="cpanel-tooltip"
                          >
                            <img
                              alt="Logout icon"
                              src="https://cdn.realsmart.co.uk/new-cpanel/cpanel-logout-icon.svg"
                              className="app-icon app-icon-wordpress"
                            />
                          </a>
                        )}
                      {this.schoolId !== "false" &&
                        this.state.school.sc_wordpress_url === "" && (
                          <a
                            href={Constants.LogoutUrl}
                            alt="app"
                            className="cpanel-tooltip"
                          >
                            <img
                              alt="Logout icon"
                              src="https://cdn.realsmart.co.uk/new-cpanel/cpanel-logout-icon.svg"
                              className="app-icon app-icon-wordpress"
                            />
                          </a>
                        )}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
      </div>
    );
  }
}

export default App;
